export const USER_REGISTERED = 'User Register';
export const USER_LOGIN = 'User Login';
export const USER_FORGOT_PASSWORD = 'User Forgot Password';
export const USER_RESET_PASSWORD = 'User Reset Password';